var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share_btn",on:{"click":function($event){return _vm.runShare()}}},[_c('button',{staticClass:"link"}),_c('div',[_vm._v(_vm._s(_vm.$t('link_copy')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }